import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-department-lookup',
  templateUrl: './micro-department-lookup.component.html'
})
export class MicroDepartmentLookupComponent  {

  @Input()
  departmentId:any;

  @Input()
  link:boolean = true;
}
